import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmDialogInput {
  message: string;
}

export type ConfirmDialogResult = true;

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: false,
})
export class ConfirmDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: ConfirmDialogInput,
    private readonly dialogRef: MatDialogRef<ConfirmDialogComponent, ConfirmDialogResult>,
  ) {
    this.dialogRef.disableClose = true;
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  public async confirm(): Promise<void> {
    this.dialogRef.close(true);
  }
}
